<template>
  <div class="dot-detail-title">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.dot-detail-title {
  font-size: 22px;
  font-weight: bold;
  color: #444444;
  line-height: 44px;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 6px;
    height: 30px;
    background: linear-gradient(0deg, #3cd4e2, #738de1);
    border-radius: 3px;
    display: inline-block;
    margin-right: 13px;
  }
}
</style>
